import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import AuthorizedAdminRouter from './AuthorizedAdminRouter';

const AdminRouter = () => {
    function isAdmin() {
        const userType = localStorage.getItem('user_type');
        return userType === "1";
    }

    const isAdminUser = isAdmin();

    return (
        <>
            <Header variant="admin" />
            <AuthorizedAdminRouter isAdmin={isAdminUser}>
                <Outlet />
            </AuthorizedAdminRouter>
            <Footer variant="admin" />
        </>
    )
}

export default AdminRouter;